import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _typeof from "@babel/runtime/helpers/typeof";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { Fragment, Children, cloneElement, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '../Icon/PantherIcon';
import Menu from '../Menu';
import './style.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Button = function Button(_ref) {
  var children = _ref.children,
    circular = _ref.circular,
    className = _ref.className,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    ghost = _ref.ghost,
    icon = _ref.icon,
    inverted = _ref.inverted,
    invisible = _ref.invisible,
    large = _ref.large,
    onClick = _ref.onClick,
    onHold = _ref.onHold,
    primary = _ref.primary,
    secondary = _ref.secondary,
    side = _ref.side,
    small = _ref.small,
    title = _ref.title,
    unfocusable = _ref.unfocusable,
    _ref$holdStart = _ref.holdStart,
    holdStart = _ref$holdStart === void 0 ? 300 : _ref$holdStart,
    _ref$holdStep = _ref.holdStep,
    holdStep = _ref$holdStep === void 0 ? 50 : _ref$holdStep,
    id = _ref.id;
  var node = useRef();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    menuOpen = _useState2[0],
    setMenuOpen = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    held = _useState4[0],
    setHeld = _useState4[1];
  var holdTimeout = useRef();
  var onHoldCallInterval = useRef();
  var clearHoldTimeout = function clearHoldTimeout() {
    clearTimeout(holdTimeout.current);
    clearInterval(onHoldCallInterval.current);
  };
  var holdStartSelf = function holdStartSelf() {
    onHold();
    onHoldCallInterval.current = setInterval(onHold, holdStep);
    setHeld(true);
  };
  var onMouseDown = function onMouseDown() {
    if (onHold && !disabled) {
      clearHoldTimeout();
      holdTimeout.current = setTimeout(holdStartSelf, holdStart);
    }
  };
  var onMouseOut = function onMouseOut() {
    if (onHold) {
      clearHoldTimeout();
      if (held) {
        setHeld(false);
      }
    }
  };
  var onTouchStart = function onTouchStart(evt) {
    evt.stopPropagation();
    onMouseDown(evt);
  };
  var onTouchEnd = function onTouchEnd(evt) {
    evt.stopPropagation();
    onMouseOut(evt);
  };
  var addTouchListeners = function addTouchListeners() {
    node.current.addEventListener('touchstart', onTouchStart);
    node.current.addEventListener('touchend', onTouchEnd);
  };
  var removeTouchListeners = function removeTouchListeners() {
    var _node$current, _node$current2;
    (_node$current = node.current) === null || _node$current === void 0 ? void 0 : _node$current.removeEventListener('touchstart', onTouchStart);
    (_node$current2 = node.current) === null || _node$current2 === void 0 ? void 0 : _node$current2.removeEventListener('touchend', onTouchEnd);
  };
  useEffect(function () {
    if (typeof onHold === 'function') {
      addTouchListeners();
    }
    return function () {
      if (typeof onHold === 'function') {
        removeTouchListeners();
      }
    };
  }, []);
  var onHoldRef = useRef();
  useEffect(function () {
    if (onHoldRef.current && !onHold) {
      removeTouchListeners();
    } else if (!onHoldRef.current && onHold) {
      addTouchListeners();
    }
  }, [onHold]);
  useEffect(function () {
    if (disabled && held) {
      clearHoldTimeout();
    }
  }, [disabled]);
  var onClickSelf = function onClickSelf(e) {
    if (!disabled) {
      if (onClick) {
        onClick(e);
      }
      setMenuOpen(!menuOpen);
    }
  };
  var onBlur = function onBlur() {
    setMenuOpen(false);
  };
  var onKeyPress = function onKeyPress(e) {
    if (e.charCode === 32) {
      onClickSelf(e);
    } else if (e.charCode === 13) {
      onClickSelf(e);
    }
  };
  var iconInsert = null;
  if (icon) {
    // determine icon
    iconInsert = /*#__PURE__*/_jsx(Icon, {
      icon: icon
    });
  }
  var hasContent = false;
  var content = Children.map(children, function (child) {
    if (child) {
      if (typeof child === 'string' || typeof child === 'number') {
        hasContent = true;
        return /*#__PURE__*/_jsx("div", {
          className: "ptr-button-caption",
          children: child
        });
      } else if (_typeof(child) === 'object' && child.type === Fragment) {
        hasContent = true;
        return /*#__PURE__*/_jsx("div", {
          className: "ptr-button-content",
          children: child
        });
      } else if (_typeof(child) === 'object' && child.type === Menu) {
        var props = _objectSpread(_objectSpread({}, child.props), {}, {
          open: !!menuOpen,
          className: classNames(child.props.className, 'ptr-button-menu')
        });
        return /*#__PURE__*/cloneElement(child, props, child.props.children);
      } else {
        hasContent = true;
        return child;
      }
    }
  });
  var classes = classNames('ptr-button', {
    circular: !!circular,
    disabled: disabled,
    ghost: !!ghost,
    icon: !!iconInsert && !hasContent,
    invisible: !!invisible,
    inverted: !!inverted,
    large: !!large,
    primary: !!primary,
    secondary: !!secondary,
    side: !!side,
    'side-left': side === 'left',
    'side-right': side === 'right',
    'side-top': side === 'top',
    'side-bottom': side === 'bottom',
    small: small
  }, className);
  return /*#__PURE__*/_jsxs("div", {
    className: classes,
    id: id,
    onBlur: onBlur,
    onClick: onClickSelf,
    onKeyPress: onKeyPress,
    tabIndex: disabled || unfocusable ? '-1' : '0',
    title: title,
    ref: node,
    onMouseLeave: onMouseOut,
    onMouseDown: onMouseDown,
    onMouseUp: onMouseOut,
    children: [iconInsert, content]
  });
};
Button.propTypes = {
  circular: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  ghost: PropTypes.bool,
  icon: PropTypes.string,
  inverted: PropTypes.bool,
  invisible: PropTypes.bool,
  large: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  onHold: PropTypes.func,
  primary: PropTypes.bool,
  secondary: PropTypes.bool,
  side: PropTypes.string,
  small: PropTypes.bool,
  title: PropTypes.string,
  unfocusable: PropTypes.bool,
  holdStart: PropTypes.number,
  holdStep: PropTypes.number,
  children: PropTypes.node,
  id: PropTypes.string
};
export default Button;
export var Buttons = function Buttons(_ref2) {
  var vertical = _ref2.vertical,
    children = _ref2.children;
  return /*#__PURE__*/_jsx("div", {
    className: classNames('ptr-buttons', {
      vertical: vertical
    }),
    children: children
  });
};
Buttons.propTypes = {
  children: PropTypes.node,
  vertical: PropTypes.bool
};
export var ButtonGroup = function ButtonGroup(_ref3) {
  var vertical = _ref3.vertical,
    className = _ref3.className,
    children = _ref3.children;
  return /*#__PURE__*/_jsx("div", {
    className: classNames('ptr-button-group', className, {
      vertical: vertical
    }),
    children: children
  });
};
ButtonGroup.propTypes = {
  children: PropTypes.node,
  vertical: PropTypes.bool,
  className: PropTypes.string
};